import React from 'react'
import ContentHeading from './ContentHeading'
import ContentList from './ContentList'

const ContentSection = ({ icon, subtitle, title, text, imageSrc, items }) => {
  return (
    <div className="dealmed-content-section">
      <div className="dealmed-container">
        <ContentHeading
          icon={icon}
          subtitle={subtitle}
          title={title}
          text={text}
          imageSrc={imageSrc}
        />
        <ContentList items={items} />
      </div>
    </div>
  )
}

export default ContentSection
